<template>
  <div class="search">
      <div class="icon__search">
          <span   @click="close_search" class="input_icons mdi mdi-arrow-left"></span>
      </div>
      <div class="input__search">
        <input 
            v-on:input="searchProduct"
            v-model="text"
            type="text" 
            ref="text"
            placeholder="Поиск"
            name="search" 
            :readonly="is_read"
            @focus="focus_read"
        >
      </div>
      <div class="clear_input_mob" @click="clearInput">
            <span class="mdi mdi-close" v-show="!getSearch"></span>
            <v-progress-circular v-show="getSearch" class="loader__color" indeterminate size="20"></v-progress-circular>
      </div>
      <div class="searchResultList_mob" id="searchResultList_mob_scroll">
          <div 
            class="list_search"
            v-for="searchResultId in searchResult"
            :key="searchResultId.id"
            @click="productId(searchResultId.id)"
          > 
              <p>
                  {{searchResultId.title}}
              </p>
              <p>
                  <b>{{searchResultId.price | numeral('0,0')}}</b> ₸
              </p>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'searchM',
  data () {
      return {
          text: '',
          searchResult: [],
          productsAll: [],
          getSearch: false,
          is_read: true
      }
  },
  components: {
  },
  
  methods: {
      getSearchProduct() {
        if (this.searchResult.length == 0) {
            let searchResultList_mob = document.querySelector('.searchResultList_mob')
            searchResultList_mob.style.display = 'none'
        }
      },
      searchProduct() {
        this.getSearch = true
        let clear_input_mob_b = document.querySelector('.clear_input_mob')
        let searchResultList_mob = document.querySelector('.searchResultList_mob')

        if (this.text == '') {
            searchResultList_mob.style.display = 'none'
            clear_input_mob_b.style.display = 'none'
            this.getSearch = false
        } else if (this.text.length >= 4) {
            fetch(this.$apiURI + 'public/product/search?request=' + this.text + '&column=title')
            .then((res) => {
                res.json().then((data) => {
                    if (data.message == "Object with this data not found") {
                        this.searchResult = []
                        this.getSearch = false
                        searchResultList_mob.style.display = 'none'
                    } else {
                        this.searchResult = data
                        this.getSearch = false
                    }
                });
            })
            searchResultList_mob.style.display = 'block'
            clear_input_mob_b.style.display = 'block'
        } else if (this.text.length <= 4) {
            this.getSearch = false
        }
      },
      close_search() {
        this.$emit('closeInput')
      },
      productId(id) {
        let searchResultList_mob = document.querySelector('.searchResultList_mob')
        searchResultList_mob.style.display = 'none'
        this.$router.push({ name: 'ProductPage', params: { id: id }})
        this.$emit('closeInput')
      },
      viewClear() {
            if (this.text == '') {
                let clear_input_mob_b = document.querySelector('.clear_input_mob')
                clear_input_mob_b.style.display = 'none'
            }
      },
      clearInput() {
        this.text = ''
        if (this.text.length == 0) {
            let clear_input_mob_b = document.querySelector('.clear_input_mob')
            let searchResultList_mob = document.querySelector('.searchResultList_mob')
            searchResultList_mob.style.display = 'none'
            clear_input_mob_b.style.display = 'none'
        }
      },
      focus_read() {
          this.is_read = false
      }
  },
  mounted() {
      this.viewClear()
      this.getSearchProduct()
  }
}
</script>

<style scoped lang="less">
.search {
    width: 100%;
    height: 40px;
    border-radius: 5px;
    border: 1px solid #ccc;
    display: flex;
    justify-content: space-between;
    position: relative;
    background: #fff; 
    .clear_input_mob {
        position: absolute;
        top: 0;
        right: 0;
        height: 40px;
        cursor: pointer;
        span {
            color: #606060;
            font-size: 34px;
        }
        .loader__color {
            color: #606060;
            margin-right: 5px;
            margin-top: 8px;
        }
    }
    #searchResultList_mob_scroll::-webkit-scrollbar-track
    {
        background-color: transparent;
    }

    #searchResultList_mob_scroll::-webkit-scrollbar
    {
        width: 10px;
    }

    #searchResultList_mob_scroll::-webkit-scrollbar-thumb
    {
        border-radius: 2px;
        background-color: #680;
    }
    .searchResultList_mob {
        width: 100%;
        position: absolute;
        top: 40px;
        left: 0;
        z-index: 100;
        height: 150px;
        overflow-y: scroll;
        
        .list_search {
            width: 100%;
            padding-top: 5px;
            background: #fff;
            padding-bottom: 5px;
            padding-left: 15px;
            border-bottom: 1px solid #680;
            cursor: pointer;
            &:hover {
                background: #f5f5f5;
            }
            p {
                color: #62644f;
                font-size: 15px;
            }
        }
    }
    .icon__search {
        width: 10%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        .input_icons {
            font-weight: bold;
            font-size: 26px;
        }
        &:hover {
            opacity: 0.7;
        }
        img {
            width: 24px;
            height: 24px;
        }
    }
    .input__search {
        width: 90%;
        height: 100%;
        input {
            width: 100%;
            height: 100%;
            background: white;
            padding-left: 5px;
            outline: none;
            font-size: 20px;
        }
    }
}
</style>